module.exports = __webpack_public_path__ + "img/4417126_256.99facbd7.png";